export const CONTRIBUTOR_UPGRADE_MESSAGE = 'Upgrade to Contributor role to submit initiatives.'

export function showContributorUpgradeMessage() {
  window.alert(CONTRIBUTOR_UPGRADE_MESSAGE)
}
